export const CONTACT_US_VALIDATION_RULES = {
    first_name: {presence: true, length: {minimum: 2, maximum: 50}},
    last_name: {presence: true, length: {minimum: 2, maximum: 50}},
    email: {presence: true, email: true},
    assist_type_option: {presence: true},
    message: {presence: true, length: {minimum: 10, maximum: 1000}},
    terms_and_conditions: {checked: true},
};
